import { announcementReducer } from './announcement/announcement.reducer';
import { appReducer } from './app/app.reducer';
import { authReducer } from './auth/auth.reducer';
import { filterReducer } from './filter/filter.reducer';
import { schemaReducer } from './schema/schema.reducer';
import { settingReducer } from './setting/setting.reducer';
import { betReducer } from './bet/bet.reducer';
import { wagerReducer } from './wager/wager.reducer';
import { largeWinReducer } from './largeWin/largeWin.reducer';

const rootReducer = {
  setting: settingReducer,
  schema: schemaReducer,
  auth: authReducer,
  announcement: announcementReducer,
  filter: filterReducer,
  app: appReducer,
  bet: betReducer,
  wager: wagerReducer,
  largeWin: largeWinReducer,
};

export default rootReducer;
